import { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { API_BASE_URL } from "../../config/apiConfig";

const QuestionReview = () => {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [filterYear, setFilterYear] = useState("");
    const [filterSubject, setFilterSubject] = useState("");
    const [filterExamType, setFilterExamType] = useState("");

    useEffect(() => {
        const fetchSolved = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/review-tests/`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("token")}`
                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Failed to fetch questions");
                }

                const incomplete = await response.json();
                setData(incomplete.data);
                console.log("Fetched Questions:", incomplete.data);
            } catch (error) {
                console.error("Error fetching questions:", error.message);
            }
        };

        fetchSolved();
    }, []);

    // Group data by year, subject, and examType
    const groupedData = {};
    data.forEach((q) => {
        const key = `${q.year}-${q.subject}-${q.examType}-${q.question_id}`;
        if (!groupedData[key]) {
            groupedData[key] = { ...q };
        } else {
            groupedData[key].questionCorrect ||= q.questionCorrect;
            groupedData[key].answerPresent ||= q.answerPresent;
            groupedData[key].imageCorrect ||= q.imageCorrect;
            groupedData[key].imagePresent ||= q.imagePresent;
        }
    });

    // Convert grouped data into an array with new IDs
    let newId = 1;
    const tableData = Object.values(groupedData).map(q => ({ id: newId++, ...q }));

    // Filtered Data
    const filteredData = tableData.filter((q) => {
        return (
            (search === "" || q.subject.toLowerCase().includes(search.toLowerCase()) || q.examType.toLowerCase().includes(search.toLowerCase())) &&
            (filterYear === "" || q.year.toString() === filterYear) &&
            (filterSubject === "" || q.subject === filterSubject) &&
            (filterExamType === "" || q.examType === filterExamType)
        );
    });


    

    return (
        <div className="p-6 bg-blue-50 min-h-screen">
            <div className="max-w-6xl mx-auto bg-white shadow-md rounded-lg p-6">
                <h2 className="text-2xl font-bold text-blue-700 mb-4">Grouped Question Review</h2>

                {/* Filters and Search */}
                <div className="mb-4 flex flex-wrap gap-4">
                    <input
                        type="text"
                        placeholder="Search by subject or exam type..."
                        className="border p-2 rounded w-full sm:w-1/3"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <select className="border p-2 rounded w-full sm:w-1/6" value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
                        <option value="">All Years</option>
                        {[...new Set(tableData.map((q) => q.year))].map((year) => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>
                    <select className="border p-2 rounded w-full sm:w-1/6" value={filterSubject} onChange={(e) => setFilterSubject(e.target.value)}>
                        <option value="">All Subjects</option>
                        {[...new Set(tableData.map((q) => q.subject))].map((subject) => (
                            <option key={subject} value={subject}>{subject}</option>
                        ))}
                    </select>
                    <select className="border p-2 rounded w-full sm:w-1/6" value={filterExamType} onChange={(e) => setFilterExamType(e.target.value)}>
                        <option value="">All Exam Types</option>
                        {[...new Set(tableData.map((q) => q.examType))].map((examType) => (
                            <option key={examType} value={examType}>{examType}</option>
                        ))}
                    </select>
                </div>

                {/* Table */}
                <table className="w-full border-collapse border border-gray-300">
                    <thead>
                        <tr className="bg-blue-200">
                            <th className="border p-2">New QID</th>
                            <th className="border p-2">Year</th>
                            <th className="border p-2">Subject</th>
                            <th className="border p-2">Exam Type</th>
                            <th className="border p-2">Is the question clear?</th>
                            <th className="border p-2">Is the correct answer present in A-D?</th>
                            <th className="border p-2">Is the image above clear?</th>
                            <th className="border p-2">Does the image relate to the question?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((q) => (
                                <tr key={q.id} className="bg-blue-50 border-b">
                                    <td className="border p-2">{q.id}</td>
                                    <td className="border p-2">{q.year}</td>
                                    <td className="border p-2">{q.subject}</td>
                                    <td className="border p-2">{q.examType}</td>
                                    <td className="border p-2 text-center">
                                        {q.questionCorrect ? <FaCheckCircle className="text-green-500 text-xl" /> : <FaTimesCircle className="text-red-500 text-xl" />}
                                    </td>
                                    <td className="border p-2 text-center">
                                        {q.answerPresent ? <FaCheckCircle className="text-green-500 text-xl" /> : <FaTimesCircle className="text-red-500 text-xl" />}
                                    </td>
                                    <td className="border p-2 text-center">
                                        {q.imagePresent !== null ? (
                                            q.imageCorrect ? <FaCheckCircle className="text-green-500 text-xl" /> : <FaTimesCircle className="text-red-500 text-xl" />
                                        ) : "No image"}
                                    </td>
                                    <td className="border p-2 text-center">
                                        {q.imagePresent !== null ? <FaCheckCircle className="text-green-500 text-xl" /> : "No image"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center p-4">
                                    No questions found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default QuestionReview;
